import {NICECampaign} from './NICE_Campaign.model';
import {NICEAgent} from './NICE_Agent.model';
import {NICESkill} from './NICE_Skill.model';
import {NICETeam} from './NICE_Team.model';

export class NICEAddressBook {
    addressBookName: string;
    addressBookId: string;
    addressBookType: string;
    appId: string;
    agents: (NICEAgent)[] | null;
    campaigns: (NICECampaign)[] | null;
    skills: (NICESkill)[] | null;
    teams: (NICETeam)[] | null;
    businessUnit: number;
    entities: string;

    constructor(jsonData?) {
        if (jsonData) {
            this.addressBookName = jsonData.addressBookName;
            this.addressBookId = jsonData.addressBookId;
            this.addressBookType = jsonData.addressBookType;
            this.appId = jsonData.appId;
            this.entities = '';
            if (jsonData.agents) {
                this.agents = jsonData.agents.map(data => new NICEAgent(data));
                this.entities = this.entities + 'Agents<br/>';
            }
            if (jsonData.skills) {
                this.skills = jsonData.skills.map(data => new NICESkill(data));
                this.entities = this.entities + 'Skills<br/>';
            }
            if (jsonData.teams) {
                this.teams = jsonData.teams.map(data => new NICETeam(data));
                this.entities = this.entities + 'Teams<br/>';
            }
            if (jsonData.campaigns) {
                this.campaigns = jsonData.campaigns.map(data => new NICECampaign(data));
                this.entities = this.entities + 'Campaigns<br/>';
            }
            this.businessUnit = jsonData.businessUnit;
            if (this.entities) {
                this.entities = this.entities.substr(0, this.entities.length - 5);
            }
        }
    }
}
